var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionView',_vm._g({staticClass:"cross-button"},_vm.$listeners),[_c('img',{staticClass:"cross-button__img",attrs:{"src":_vm.icon,"alt":"cross button","width":"14","height":"14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }